
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.767 3.218l-2.25 3.208A1 1 0 003.338 8h17.327a1 1 0 00.818-1.574l-2.25-3.208A3 3 0 0016.82 2H7.18a3 3 0 00-2.414 1.218zM21.36 11.6a1 1 0 00-.8-1.6H3.44a1 1 0 00-.8 1.6l6.98 9.295a3 3 0 004.76 0l6.98-9.294z"}})])
          )
        }
      }
    